var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabs"},[_c('div',{staticClass:"weui-tabs-bar__wrp"},[_c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"weui-tabs-bar__content",attrs:{"id":"tab-scroll"}},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,attrs:{"id":'item_' + index}},[_c('div',{staticClass:"weui-tabs-bar__item",style:({
              backgroundColor: _vm.tabBackgroundColor,
              color:
                _vm.activeTab == index ? _vm.tabActiveTextColor : _vm.tabInactiveTextColor
            }),on:{"click":function($event){return _vm.handleTabClick(index)}}},[_c('div',{staticClass:"top-nav-item",class:[
                _vm.tabClass,
                _vm.activeTab === index ? 'top-nav-item-active' : ''
              ],style:({
                borderBottomColor:
                  _vm.activeTab === index ? _vm.tabUnderlineColor : 'transparent'
              })},[_c('span',{},[_vm._v(_vm._s(item))])])])])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }